export const stats = [
  { value: '+60', label: 'Units Ready' },
  { value: '+2,000', label: 'Teachers Satisfied' },
  { value: '3,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+60', label: 'Ready-to-Teach Units' },
  { value: '10', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours planning every single math class',
  'Repetitive and dry exercises',
  'No clear connection to the real world',
  'Not knowing how to grade or assess properly',
  'Unmotivated students who "hate math"',
]

export const afterItems = [
  "5-minute review and you're set",
  'Visual and engaging math projects',
  'Real-world applications integrated',
  'Quizzes, exams, and answer keys ready',
  'Students mastering concepts with confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving to class without knowing exactly how to explain a complex topic',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find math worksheets that are actually high-quality and visual',
  },
  {
    emoji: '📋',
    text: 'No clear assessments or rubrics aligned with the school year',
  },
  {
    emoji: '😴',
    text: "Students falling behind because the material isn't connected",
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Primary Volumes (Grades 1–5)',
    text: 'A full elementary year fully planned',
  },
  {
    emoji: '🏛️',
    title: '5 Secondary Volumes (Grades 6–10)',
    text: 'From basic algebra to calculus foundations',
  },
  {
    emoji: '✏️',
    title: 'Step-by-Step Lesson Scripts',
    text: 'Ready to follow and teach in seconds',
  },
  {
    emoji: '📐',
    title: 'Visual Theory & Worksheets',
    text: 'High-quality graphics ready to print',
  },
  {
    emoji: '📊',
    title: 'Assessments & Final Exams',
    text: 'Complete tools for every single grade',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Grading is finally instant and stress-free',
  },
]

export const lookInside = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/t1cpcSMkSqMrh5UmjZTMgN/Captura-de-pantalla-2026-09-11-a-las-4.29.30_p._m._(1).webp',
    level: 'Primary 1 · Numbers & Counting',
    title: 'Lesson 1 — Counting to 5',
    text: 'Teacher script on the left, student worksheet on the right. Print one page and the whole class is running.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/c6LzovxqyNjT8C1MU26X2i/Captura-de-pantalla-2026-09-11-a-las-4.30.36_p._m..webp',
    level: 'Primary 3 · Place Value',
    title: 'Activity 3 — Comparing & Ordering Numbers',
    text: 'Guided practice with an example, two difficulty blocks, a teaching tip and a built-in score box.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/aAK3vqgX65z5aZEreTJuyM/Captura-de-pantalla-2026-09-11-a-las-4.31.17_p._m..webp',
    level: 'Volume 3 · Multiplication',
    title: 'What Is Multiplication? (Deeper Dive)',
    text: 'Five ways to model 3 × 4 explained visually, then the same five models handed back to the student.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/f9WoQuXYEZy34h1Ym1bWrn/Captura-de-pantalla-2026-09-11-a-las-4.31.55_p._m..webp',
    level: 'Teacher Reference',
    title: 'Fraction Fundamentals Guide',
    text: 'Interpretations, vocabulary hierarchy and the misconceptions your students will bring — with how to fix them.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/iGxtoupGAA6UmbJ95h2Me2/Captura-de-pantalla-2026-09-11-a-las-4.32.45_p._m..webp',
    level: 'Teacher Reference',
    title: 'Algorithm Strategy Guide',
    text: 'Every fraction and decimal operation with its visual model and the exact error students make.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/b2bSTcZKuTNjtYBzbXtUC8/Captura-de-pantalla-2026-09-11-a-las-4.34.16_p._m..webp',
    level: 'Secondary · Ratios & Proportions',
    title: 'Lesson 1 — What Is a Ratio?',
    text: 'Visual introduction with real examples, the three notations side by side, and an 8-item context activity.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tFXqHDccSQXHepVrou7fY5/Captura-de-pantalla-2026-09-11-a-las-4.35.08_p._m..webp',
    level: 'Secondary · Intro to Algebra',
    title: 'Lesson 1 — What Are Variables?',
    text: 'Notation explained, two activities with worked examples and a ready-to-print 8-question mini-quiz.',
  },
]

export const instantItems = [
  'The 10 complete digital volumes (Primary and Secondary Series)',
  'Activities, projects, and assessments by level',
  'Step-by-step visual lessons for every mathematical concept',
  'Teacher scripts that tell you exactly what to say',
  'Answer keys for every worksheet and exam in the system',
]

export const bonuses = [
  {
    title: 'The 10-Minute Math Ready Setup Guide',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/15f9d9fe-5740-44a8-84a9-b8a2dfdae7f6.jpg',
  },
  {
    title: 'The Mental Math Warm-Up Vault (100 Prompts)',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d472769-7ebe-45d4-8854-8cf06f25e37c.jpg',
  },
  {
    title: 'The Real-World Math Hook Bank (50 Scenarios)',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e32f8f1-b78d-4071-b672-aaf79c77da8e.jpg',
  },
  {
    title: 'The Differentiation Quick-Fix Matrix',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c9cd780c-e429-42c5-bd30-c8084aba3a9d.jpg',
  },
  {
    title: 'The Parent Update & Progress Pack',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3fed2a43-aa7e-4d8f-b949-9026d0cd5fd4.jpg',
  },
]

export const offerRows = [
  { label: 'Math Ready Pack (10 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Bonuses', value: '$135' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from Grade 1 to 10 is exactly what I needed.',
    name: 'Sarah M.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The visual lessons make a huge difference for my students who used to struggle.',
    name: 'Ella B.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'The differentiation matrix alone saved my class this year. Worth every penny.',
    name: 'Maya K.',
    location: 'Canada 🇨🇦',
  },
  {
    quote:
      'Finally, a math resource that is actually organized and ready to print.',
    name: 'Sophie L.',
    location: 'Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instantly via email after purchase.',
  },
  {
    q: "Does this work if I'm a beginner teacher?",
    a: 'Yes, the scripts make it open-and-go.',
  },
  {
    q: 'What grade levels does this cover?',
    a: 'Full coverage from Grade 1 through Grade 10.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, only during this launch offer.',
  },
  {
    q: 'What file format are the volumes in?',
    a: 'High-resolution, print-ready PDF files.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. One-time payment, lifetime access.',
  },
]
